import { useEffect } from 'react'
import { useMediaQuery } from 'react-responsive'
import { create } from 'zustand'

import type { HubType } from '@/stores/HubStore'
import { useHubStore } from '@/stores/HubStore'

type MobileLayoutState = {
  isMobile: boolean
  activeMobileTab: HubType
  setIsMobile: (isMobile: boolean) => void
  setActiveMobileTab: (type: HubType) => void
}

const useMobileLayoutStore = create<MobileLayoutState>((set, get) => ({
  isMobile: false,
  activeMobileTab: 'control',

  setIsMobile: (isMobile) => {
    const resetHubs = useHubStore.getState().resetHubs
    const filterHubs = useHubStore.getState().filterHubs

    set({ isMobile })

    if (isMobile) {
      filterHubs(get().activeMobileTab)
    } else {
      resetHubs()
    }
  },
  setActiveMobileTab: (type) => {
    const filterHubs = useHubStore.getState().filterHubs

    set({ activeMobileTab: type })
    if (get().isMobile) {
      filterHubs(type)
    }
  },
}))

const useWatchMobile = () => {
  const isMobileMedia = useMediaQuery({ query: '(max-width: 900px)' })
  const { setIsMobile } = useMobileLayoutStore()

  useEffect(() => {
    setIsMobile(isMobileMedia)
  }, [isMobileMedia, setIsMobile])
}

export { useMobileLayoutStore, useWatchMobile }
